import { rem } from 'polished'
import styled from 'styled-components'

export const ImporterUploaderStyled = styled.div`
  font-size: ${rem(16)};

  width: 100%;
  position: relative;
  flex-grow: 1;

  padding-top: ${rem(50)};
  padding-bottom: 1.5em;

  .error-message {
    position: absolute;
    left: 0;
    right: 0;
  }
`
